const PonduranceSvgIcon = ({
  fillcolor = '#df2345',
  height = 20.25,
  outline = false
}: {
  fillcolor?: string;
  height?: number | string;
  outline?: boolean;
}) => {
  if (outline) {
    return (
      <svg
        height={height}
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="0 0 70 110"
      >
        <path
          stroke="#FFF"
          strokeWidth={5}
          d="M26,12.5l-20.4,6.7c-2.1.6-3.6,2.5-3.6,4.6v79.4c0,.2,0,.5,0,.7.1.5.5.9.5,1.4,1.1,1.8,3.5,2.9,5.7,2.3l19.5-5c2.1-.6,4-3.4,4-6V17.5c0-3.1-2.6-6.1-6-5Z"
        />
        <path
          stroke="#FFF"
          strokeWidth={5}
          d="M62,2.5l-20.5,5.8c-2.1.6-3.5,3.1-3.5,5.2v44c0,2.7,2.3,5,5,5h20c2.7,0,5-2.3,5-5V7.5c0-.8-.4-2-.7-2.6-1-2.1-2.9-3.1-5.3-2.4Z"
        />
      </svg>
    );
  }

  return (
    <svg
      height={height}
      viewBox="0 0 66 105"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.59 16.65C1.53 17.26 0.120003 19.14 0.120003 21.29V100.23C0.120003 100.38 0.160002 100.52 0.170002 100.66C0.190002 100.89 0.200002 101.14 0.250002 101.36C0.370002 101.85 0.580002 102.3 0.830002 102.71C1.92 104.5 4.11 105.51 6.31 104.86L26.45 98.93C28.51 98.32 29.92 96.44 29.92 94.29V15.36C29.92 12.26 27.06 10.03 24.09 10.66C23.97 10.69 23.84 10.69 23.72 10.73L3.59 16.65Z"
        fill={fillcolor}
      />
      <path
        d="M59.61 -0.139999L39.47 5.79C37.41 6.39 36 8.28 36 10.43V54.8C36 57.47 38.16 59.63 40.83 59.63H60.97C63.64 59.63 65.8 57.47 65.8 54.8V4.5C65.8 3.75 65.62 3.05 65.32 2.43C64.35 0.370001 61.99 -0.839999 59.61 -0.139999Z"
        fill={fillcolor}
      />
    </svg>
  );
};

export default PonduranceSvgIcon;
